module.exports = __webpack_public_path__ + "img/card_12.7b342be8.png";